import { useLayoutEffect } from "react";
import { markFallbackShown } from "./pageLoadStatus";

/**
 * Резервното съдържание на общата Suspense граница в `main.tsx`. Показва се
 * само когато пред него НЯМА стар екран за задържане — отваряне направо по
 * адрес, след вход с ПИН. Тогава до него обикновено е стоял spinner-ът на
 * `AuthorizedRoute`, затова spinner-ът (`PageLoadingIndicator`) идва веднага,
 * без пауза — иначе би примигнал празен кадър.
 */
export default function PageLoading() {
  useLayoutEffect(() => markFallbackShown(), []);
  return <div className="h-screen" />;
}
